import { PartialLayerSpec } from '@/utils/layers/styleFactory/template'
import { ILayerValue } from '@lifk/types'
import { ExpressionSpecification } from 'mapbox-gl'

export default (
  layerValues: ILayerValue[],
  mapboxColorExpression: string | ExpressionSpecification,
  mapboxOpacityExpression?: ExpressionSpecification
): PartialLayerSpec[] => {
  const excludeFill = layerValues.some(({ styleConfig }) =>
    styleConfig.exclude.includes('fill')
  )
  return [
    {
      id: 'fill',
      type: 'fill',
      layout: {},
      paint: {
        'fill-color': excludeFill ? 'transparent' : mapboxColorExpression,
        'fill-outline-color': 'rgba(0, 0, 0, 0)',
        'fill-opacity': excludeFill ? 0 : mapboxOpacityExpression
      }
    },
    {
      id: 'stroke',
      type: 'line',
      layout: {},
      paint: {
        'line-color': mapboxColorExpression,
        'line-width': ['interpolate', ['linear'], ['zoom'], 0, 1, 9, 1, 12, 2]
      }
    },
    {
      id: 'label',
      type: 'symbol',
      layout: {
        'text-field': ['to-string', ['get', 'label']],
        'text-font': ['TWK Everett Bold', 'Arial Unicode MS Regular'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 0, 9, 10, 9, 12, 9]
      },
      paint: {
        'text-halo-color': '#ffffff',
        'text-halo-width': 1,
        'text-halo-blur': 1,
        'text-color': '#4b4c4d'
      }
    }
  ] as PartialLayerSpec[]
}
